const getRandInt = (min, max) => {
  max = max + 1;
  return new Promise((res, rej) => {
    res(Math.floor(Math.random() * (max - min) + min));
  });
};

module.exports = getRandInt;
